import type { NodeId, InputId } from 'web';
import type { FlowGraph } from '../FlowGraph';

interface ResolvedImage {
  url: string;
  width: number;
  height: number;
}

export class KlingElementView {
  constructor(
    private graph: FlowGraph,
    private id: NodeId,
  ) {}

  evaluateImageInput(inputId: InputId): ResolvedImage | undefined {
    const evaluated = this.graph.evaluateInput(this.id, inputId);
    if (evaluated?.type !== 'image') return undefined;

    if (evaluated.value.type === 'file') {
      return { url: evaluated.value.url, width: evaluated.value.width, height: evaluated.value.height };
    }

    const input = this.graph.getNodeInput(this.id, inputId);
    if (!input) return undefined;

    const rendered = this.graph.wasm.call((wasm) => wasm.exportNodeRender(input.nodeId, input.outputId));
    if (!rendered) return undefined;

    return { url: rendered.data, width: rendered.width, height: rendered.height };
  }
}
